<template>
  <div>
    <!--<bread-crumb></bread-crumb>-->

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <!-- 작성자 이름 -->
          <admin-box-item title="1:1 문의 내용">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="배대지">
                  <div>{{ value.country === 'fr' ? '프랑스' : '독일' }}</div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="작성자 이름">
                  <div v-if="value.user">{{ value.user_data.name }}</div>
                  <div v-else>{{ value.last_name }}{{ value.name }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="작성자 이메일">
                  <div v-if="value.user">{{ value.user_data.email }}</div>
                  <div v-else>{{ value.email }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="작성자 연락처">
                  <div v-if="value.user">{{ value.user_data.phone }}</div>
                  <div v-else>{{ value.phone }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="문의유형">
                  <div>{{ value.type }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="제목">
                  <div>{{ value.title }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="내용">
                  <textarea class="textarea"
                            v-model="value.content"
                            readonly></textarea>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="첨부파일">
                <div class="flex-align">
                  <template v-for="(img,idx) in value.imgs">
                    <a :href="img" target="_blank">
                      <div class="img-attach" v-if="isImage(img)" :style="imgField(img)" :key="'attach-file-'+idx"></div>
                      <div v-else class="img-attach">
                        <i class="material-icons" style="font-size:16px;vertical-align: middle;color:#999">attach_file</i>파일 {{ idx+1 }}
                      </div>
                    </a>
                  </template>
                </div>
                </admin-form-item>
              </div>

            </div>
          </admin-box-item>

          <!--&lt;!&ndash; 질문 내용 &ndash;&gt;
          <div class="lp-bg-sub-in-group">
            <div class="ask-content" style="width: 800px; height: 200px; padding: 12px 16px; overflow-y: auto;">{{ askContent.content }}</div>
            <div class="flex" v-if="askContent.imgs !== undefined && askContent.imgs.length>0">
              <div v-for="(img,idx) in askContent.imgs" :key="'qimg'+idx">
                <div @click="clickImg(img)">
                  <image-cropped :height="80" :img="img"
                                 :square="true" style="width:80px;margin-right:8px"></image-cropped>
                </div>
                <div class="lp-img-bg" v-if="vFull" @click="vFull=false">
                  <img class="lp-img-full" :src="image(fullImg)">
                </div>
              </div>
            </div>
          </div>-->
        </div>

        <div class="box">
          <admin-box-item title="1:1 문의 답변 등록">
            <div class="columns is-multiline">
              <div class="column is-full">
                <div class="comment-sub-title" style="margin-top:20px;margin-bottom: 20px;">댓글 작성</div>
                <admin-form-item label="작성자">
                  관리자
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="작성 내용">
                  <div class="flex">
                    <div style="margin-right:12px;width:90%">
                      <textarea class="textarea" v-model="value.answer_content"></textarea>
                    </div>
                    <div>
                      <button class="button is-primary"
                              style="height: 100% !important"
                              @click="clickCommentsReg">등록</button>
                    </div>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";

  export default {
    layout: 'Main',
    components: {
      LpAdmDropInput
    },
    created() {
      this.getData();
    },
    computed: {
    },
    methods: {
      // 답변 등록
      clickCommentsReg() {
        let param = {
          admin_id: this.$store.getters.admin.id,
          user_type: 'admin',
          answer_content: this.value.answer_content
        }
        this.$axios.patch(this.getUrl('inquiry/personal/'+this.$route.query.id), param
        ).then(res=>{
          if(res.status===200){
            this.toast('완료되었습니다.');
            this.$router.replace(this.getPath('cs/inquiry/all'))
          }
        })

      },
      getData(){
        if(this.$route.query.id){
          this.$axios.get(this.getUrl('inquiry/personal/')+this.$route.query.id)
            .then(res=>{
              this.value = res.data;
              if(res.data.user_type==='admin'){
                this.value.user_id = res.data.admin;
              }
              else if(res.data.user_type==='partner'){
                this.value.user_id = res.data.partner;
              }

              //this.getUsername();
            })
        }
      },
      isImage(img) {
        let result = false;
        ['.jpg', '.jpeg', '.png', '.JPEG', '.JPG', '.PNG', '.gif', '.GIF', '.bmp', '.BMP'].forEach(ext => {
          if(img.indexOf(ext)>-1) {
            result = true;
          }
        });
        return result;
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;margin-right: 12px';
      },
    },
    data () {
      return {
        id: 0,
        // 문의 내용
        value: {
          country: 'de',
          name: '',
          email: '',
          phone: '',
          type: '',
          title: '',
          content: '',
          user_type: 'admin',
          user_id: '',
          answer_content: '',
          user_data: {}
        },
        userlist: [],
        username: '',
        vFull: false,
        fullImg: ''
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .comment-sub-title
    background #ddd
    color #333
    padding 8px 16px
    font-size 0.95rem
    border-radius 3px
    display flex
    justify-content space-between

  .ask-content
    width 260px
    padding 6px 10px
    font-size .85rem
    color #555
    border-radius 3px
    display inline-block
    border 1px solid #ddd

  .lp-img-bg
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba(0,0,0,0.5)
    z-index 100

  .lp-img-full
    position fixed
    top 50%
    left 50%
    transform translate(-50%, -50%)
    max-height 80vh

  .img-attach
    border 2px solid #dddddd
    width 60px
    height 60px
    line-height 56px
    font-size 14px
  .img-attach:hover
    border 2px solid #ff5722

</style>
